import api from './request';

/**
 * Get all consumers
 */
export const getAllConsumersRequest = (page = 1) => {
    return api
        .request(`consumer?page=${page}`)
        .get();
};

/**
 * Search consumer by first or last name
 */
export const searchConsumerRequest = (params) => {
    return api
        .request("search/consumer")
        .withParams(params)
        .get();
};

/**
 * Search consumer by QR code
 */
export const searchConsumerByQrCodeRequest = (params) => {
    return api
        .request("search/consumer-qr-code")
        .withParams(params)
        .get();
};

/**
 * get consumer by ID
 */
export const getConsumerById = (id) => {
    return api
        .request("consumer/" + id)
        .get();
};
